import React, { useEffect, useState } from 'react';
import { LocalMarketing } from './pages/LocalMarketing';
import { GoogleMapsScraper } from './pages/GoogleMapsScraper';
import { LocalBusinessDatabase } from './pages/LocalBusinessDatabase';
import { LocalBusinessEnrichment } from './pages/LocalBusinessEnrichment';
import { OwnerFinder } from './pages/OwnerFinder';
import { EmailSequencing } from './pages/EmailSequencing';
import { AccountingDatabase } from './pages/AccountingDatabase';
import { AccountingNYC } from './pages/AccountingNYC';
import { DataDirectory } from './pages/DataDirectory';
import { Features } from './pages/Features';
// Original page components
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { AlternativeSection } from './components/AlternativeSection';
import { ApiPlayground } from './components/ApiPlayground';
import { ComparisonTable } from './components/ComparisonTable';
import { FieldCoverage } from './components/FieldCoverage';
import { PricingValue } from './components/PricingValue';
import { UseCases } from './components/UseCases';
import { FAQ } from './components/FAQ';
import { RelatedFeatures } from './components/RelatedFeatures';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
function LocalBusinessAPI() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <FieldCoverage data-id="element-5" />
        <AlternativeSection data-id="element-6" />
        <ApiPlayground data-id="element-7" />
        <ComparisonTable data-id="element-8" />
        <PricingValue data-id="element-9" />
        <UseCases data-id="element-10" />
        <FAQ data-id="element-11" />
        <RelatedFeatures data-id="element-12" />
        <CtaBanner data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash || '#/');
  useEffect(() => {
    const onHashChange = () => {
      setCurrentPath(window.location.hash || '#/');
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPath) {
      case '#/':
        return <Features data-id="element-15" />;
      case '#/local-business-api':
        return <LocalBusinessAPI data-id="element-16" />;
      case '#/google-maps-scraper':
        return <GoogleMapsScraper data-id="element-17" />;
      case '#/local-business-database':
        return <LocalBusinessDatabase data-id="element-18" />;
      case '#/local-business-enrichment':
        return <LocalBusinessEnrichment data-id="element-19" />;
      case '#/owner-finder':
        return <OwnerFinder data-id="element-20" />;
      case '#/email-sequencing':
        return <EmailSequencing data-id="element-21" />;
      case '#/data':
        return <DataDirectory data-id="element-22" />;
      case '#/data/accounting':
        return <AccountingDatabase data-id="element-23" />;
      case '#/data/accounting-new-york-city':
        return <AccountingNYC data-id="element-24" />;
      default:
        return <Features data-id="element-25" />;
    }
  };
  return renderPage();
}